import Vue from 'vue'

import kcAxios from './kcAxios'
// Vue.use(kcAxios)
import kcMessage from './kcMessage'
// Vue.use(kcMessage)
import kcTools from './kcTools'
// Vue.use(kcTools)
import kcValidate from './kcValidate'
// Vue.use(kcValidate)
import kcTemplet from './keTemp/_keTemp.js'

Vue.use(kcTemplet);
/*import index from './index.js'
Vue.use(index);*/


import kcVueBase from './kcVueBase'
Vue.prototype.kcVueBase=kcVueBase;



// WEBPACK FOOTER //
// ./src/kc/index.js